import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html'
})
export class ModalContainerComponent implements AfterViewInit {

  @Input() component: any;
  @Input() componentInputs: any = {};
  @Input() title?: string;
  @Output() cerrar = new EventEmitter<any>();

  @ViewChild('host', { read: ViewContainerRef })
  host!: ViewContainerRef;

  constructor(
    public bsModalRef: BsModalRef,
    private resolver: ComponentFactoryResolver
  ) {}

  ngAfterViewInit(): void {
    const factory = this.resolver.resolveComponentFactory(this.component);
    const ref = this.host.createComponent(factory);

    const instance: any = ref.instance;

    if (this.componentInputs) {
      Object.assign(instance, this.componentInputs);
    }

    if (instance?.cerrar?.subscribe) {
      instance.cerrar.subscribe(evento => {
        this.cerrar.emit(evento);
        this.bsModalRef.hide();
      });
    }
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
